<template lang='pug'>
  .edit
    .edit-header
      .edit-close(@click='close')
        i.fa.fa-chevron-left
      h4.edit-title
        | {{ landing_page_widget.widget.name | remove_hyphens }} Widget
    .edit-image(v-if='show_uploader')
      uploader(
        :hero='is_hero'
        :landing_page_widget='landing_page_widget'
        :asset_public_id='landing_page_widget.draft_content.asset_public_id'
        :external_video_url='landing_page_widget.draft_content.external_video_url'
        :brand_id='brand.id'
        :campaign_id='campaign.id'
        :accepted_resource_types='accepted_resources'
        @input='update_widget')
    .edit-image(v-if='show_carousel')
      carousel_edit(
        :landing_page_widget='landing_page_widget'
        :brand_id='brand.id'
        :campaign_id='campaign.id'
        accepted_resource_types='image/*'
        @input='update_widget')
    .edit-overlay(v-if='is_hero')
      overlay(
        :landing_page='landing_page'
        :landing_page_widget='landing_page_widget'
        @input='update_widget')
    .rich_text_editor(v-if='show_rich_text')
      rich_text(
        :brand='brand'
        :is_hero='is_hero'
        :is_html='is_html'
        :landing_page='landing_page'
        :landing_page_widget='landing_page_widget'
        @input='update_widget')
    .divider(v-if='is_divider')
      divider(
        :landing_page_widget='landing_page_widget'
        @input='update_widget')
    .shares_edit(v-if='is_shares')
      shares_edit(
        :landing_page_widget='landing_page_widget'
        :selected_share_id='selected_share_id'
        :brand='brand'
        @input='update_widget'
        @change_selected_share='change_selected_share')
    .form_edit(v-if='is_form')
      form_edit(
        :brand='brand'
        :campaign='campaign'
        :retailer='retailer'
        :landing_page_widget='landing_page_widget'
        @input='update_widget')
    .hero_button_toggle(v-if='is_hero')
      el-button(
        v-if='!cta_checked'
        @click='toggle_hero_show_button'
        )
        | Display Button
      el-button(
        v-if='cta_checked'
        @click='toggle_hero_show_button'
        )
        | Remove Button
    .cta(v-if='is_cta_widget && show_cta')
      cta(
        :brand='brand'
        :campaign_id='campaign.id'
        :custom_fields='custom_fields'
        :retailer='retailer'
        :landing_page_widget='landing_page_widget'
        @input='update_widget')
    .edit-reverse_order(v-if='is_dual_widget')
      label.m-t-1-0
        | {{ is_video_widget ? 'Video' : 'Image' }} Placement
      el-select(
        v-model='is_reverse_order'
        placeholder='Top'
        @change='toggle_reverse')
        el-option(
          v-for="option in asset_placement_options"
          :key="option.value"
          :label="option.label"
          :value="option.value")
    .edit-reverse_order(v-if='is_dual_widget')
      .edit-reverse_order-caption.edit-reverse_order-caption-remove
        el-button(
        type="text"
        @click='remove_caption')
          | Remove Caption
    .edit-reverse_order(v-if='is_media_widget && !is_dual_widget && !is_hero' )
      .edit-reverse_order-caption
        el-button(
        @click='add_caption')
          | Add a Caption
</template>

<script>
  import _ from 'lodash'
  import { db } from '../utils/firebase'
  import uploader from './uploader.vue'
  import rich_text from './rich_text.vue'
  import divider from './divider.vue'
  import overlay from './overlay.vue'
  import cta from './cta.vue'
  import form_edit from './form_edit.vue'
  import carousel_edit from './carousel_edit.vue'
  import shares_edit from './shares_edit.vue'

  const dual_widgets = ['image_text', 'video_text']
  const video_widgets = ['video', 'video_text']
  const text_widgets = ['text', 'terms', 'hero', 'html', ...dual_widgets]
  const media_widgets = ['image', 'video', 'hero', ...dual_widgets]
  const cta_widgets = ['button', 'hero']

  export default {
    name: 'edit',
    components: {
      rich_text,
      uploader,
      divider,
      cta,
      overlay,
      form_edit,
      carousel_edit,
      shares_edit
    },
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      },
      landing_page: {
        type: Object,
        required: true
      },
      custom_fields: {
        type: Array,
      },
      campaign: {
        type: Object,
        required: true
      },
      brand: {
        type: Object,
        required: true
      },
      retailer: {
        type: Object,
        required: true
      },
      selected_share_id: {
        type: String,
        required: false
      }
    },
    inject: {
      $validator: '$validator'
    },
    filters: {
      remove_hyphens(name) {
        return name.replace(/_/g, ' + ')
      }
    },
    data() {
      return {
        cta_checked: this.landing_page_widget.draft_content.show_button ? this.landing_page_widget.draft_content.show_button : false,
        asset_placement_options: [
          {
            value: true,
            label: 'Top'
          },
          {
            value: false,
            label: 'Bottom'
          }
        ]
      }
    },
    computed: {
      show_cta() {
        return !this.is_hero ? true : this.cta_checked ? true : false
      },
      is_form() {
        return this.landing_page_widget.widget && this.landing_page_widget.widget.name === 'form'
      },
      is_shares() {
        return this.landing_page_widget.widget && this.landing_page_widget.widget.name === 'shares'
      },
      is_divider() {
        return this.landing_page_widget.widget && this.landing_page_widget.widget.name === 'divider'
      },
      is_hero() {
        return this.landing_page_widget.widget && this.landing_page_widget.widget.name === 'hero'
      },
      is_html() {
        return this.landing_page_widget.widget && this.landing_page_widget.widget.name === 'html'
      },
      show_rich_text() {
        if (this.landing_page_widget.widget) {
          return _.includes(text_widgets, this.landing_page_widget.widget.name)
        }
        return false
      },
      show_uploader() {
        if (this.landing_page_widget.widget) {
          return _.includes(media_widgets, this.landing_page_widget.widget.name)
        }
        return false
      },
      show_carousel() {
        if (this.landing_page_widget.widget) {
          return this.landing_page_widget.widget.name === 'carousel'
        }
        return false
      },
      is_dual_widget() {
        if (this.landing_page_widget.widget) {
          return _.includes(dual_widgets, this.landing_page_widget.widget.name)
        }
        return false
      },
      is_media_widget() {
        if (this.landing_page_widget.widget) {
          return _.includes(media_widgets, this.landing_page_widget.widget.name)
        }
        return false
      },
      is_cta_widget() {
        if (this.landing_page_widget.widget) {
          return _.includes(cta_widgets, this.landing_page_widget.widget.name)
        }
        return false
      },
      is_video_widget() {
        if (this.landing_page_widget.widget) {
          return _.includes(video_widgets, this.landing_page_widget.widget.name)
        }
        return false
      },
      is_reverse_order() {
        if (this.is_dual_widget) {
          return this.landing_page_widget.draft_content.reverse_order
        }
        return null
      },
      accepted_resources() {
        return this.is_video_widget ? 'video/*' : 'image/*'
      }
    },
    methods: {
      update_widget(widget) {
        this.$emit('widget_changed')
        db.collection(`landing_pages/${this.campaign.id}/landing_page_widgets`).doc(this.landing_page_widget.id).update({
          "draft_content": widget.draft_content
        })
        this.add_timestamp()
      },
      add_timestamp() {
        db.doc(`landing_pages/${this.campaign.id}`).update({updated_at: new Date()})
      },
      change(val, key) {
        this.landing_page_widget.draft_content[key] = val
        this.update_widget(this.landing_page_widget)
      },
      toggle_hero_show_button(){
        const widget = this.landing_page_widget
        widget.draft_content.show_button = !this.cta_checked
        this.update_widget(widget)
        this.cta_checked = !this.cta_checked
      },
      toggle_reverse() {
        this.landing_page_widget.draft_content.reverse_order = !this.is_reverse_order
        this.update_widget(this.landing_page_widget)
      },
      close() {
        this.$emit('close')
      },
      async remove_caption() {
        const { html, reverse_order, ...draft_content } = this.landing_page_widget.draft_content
        const name = this.landing_page_widget.widget.name.replace(/_text/g, "")
        let widget_reference = db.collection(`landing_pages/${this.campaign.id}/landing_page_widgets`).doc(this.landing_page_widget.id)

        await db.collection(`landing_pages/${this.campaign.id}/landing_page_widgets`).doc(this.landing_page_widget.id).update({
          "draft_content": draft_content,
          "widget": {
            ...this.landing_page_widget.widget,
            name: name
          },
          "id": this.landing_page_widget.id
        })
        this.add_timestamp()
        let updated_widget = await db.collection(`landing_pages/${this.campaign.id}/landing_page_widgets`).doc(this.landing_page_widget.id).get()
        updated_widget = updated_widget.data()
        this.$emit('refresh_edit_panel', updated_widget)
      },
      async add_caption() {
        const draft_content = {
          ...this.landing_page_widget.draft_content,
          reverse_order: false,
          html: ""
        }
        const name = `${this.landing_page_widget.widget.name}_text`

        await db.collection(`landing_pages/${this.campaign.id}/landing_page_widgets`).doc(this.landing_page_widget.id).update({
          "draft_content": draft_content,
          "widget": {
            ...this.landing_page_widget.widget,
            name: name
          },
          "id": this.landing_page_widget.id
        })
        this.add_timestamp()
        let updated_widget = await db.collection(`landing_pages/${this.campaign.id}/landing_page_widgets`).doc(this.landing_page_widget.id).get()
        updated_widget = updated_widget.data()
        this.$emit('refresh_edit_panel', updated_widget)
      },
      change_selected_share(share_id) {
        this.$emit('change_selected_share', share_id)
      }
    }
  }
</script>
<style lang='scss'>
  // Override inline styles to re-align this button but not affect others
  .fr-action-buttons button[data-cmd='linkInsert'] {
    position: absolute;
    left: 0;
    margin-top: 5px;
  }
</style>

<style lang='scss' scoped>
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";
  .edit {
    padding: 20px;
    overflow-y: auto;
    &-header {
      margin-bottom: 30px;
    }
    &-close,
    &-title {
      display: inline-block;
      text-align: center;
    }
    &-close {
      padding: 10px 20px 10px 5px;
      cursor: pointer;
    }
    &-title {
      width: 75%;
      cursor: default;
      text-transform: capitalize;
    }
    &-setting {
      margin-bottom: 20px;
      width: 100%;
      &-label {
        text-transform: capitalize;
        display: block;
      }
    }
    &-label {
      margin-top: 20px;
      &-checkbox {
        margin: 20px 20px 10px 0px;
      }
    }
    &-overlay {
      margin-bottom: 20px;
    }
    &-campaign_assets {
      border-top: 1px solid get-color(gray-lightest);
      &-title {
        color: get-color(gray-darkest);
        text-align: center;
        margin: 20px 0 0;
      }
      &-selector {
        height: 20vh;
        min-height: 150px;
        display: block;
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
    &-reverse_order {
      margin-top: 10px;
      &-caption {
        margin-top:30px;
        &-remove .el-button--text{
          margin-left: -10px;
        }
      }
      &-label {
        margin: 0 15px 15px 0;
      }
    }
  }
  .hero_button_toggle {
    margin-top: 30px;
    margin-bottom: 20px;
  }
  // force scroll bar for digital assets in modal
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,200,.5);
  }
</style>
